import React, { useState } from "react";
import ArrowNext from "../../assets/icons/arrownext.svg";
import CompanyNotFoundBg from "../../assets/images/bg-texture-tr.png";
import { useSelector, useDispatch } from "react-redux";
import { setCompany } from "../../store/search/searchSlice";
import { Link } from "react-router-dom";
import TorchEffect from "../../components/torchEffect/TorchEffect";

export const NotFoundCompany = ({ }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [companyNotFound, setFoundNotFound] = useState(false);
  const dispatch = useDispatch();
  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleFormSubmit = (companyData) => {
  };

  const handleSwitch = () => {
    dispatch(setCompany(null));
    setFoundNotFound((prevState) => !prevState);
  };
  const CompanyNotFoundPopup = () => {
  };

  return (
    <div className="rounded-[8px] overflow-hidden">
      <div
        className="text-left lg:max-w-sm rounded-lg shadow p-5"
        style={{
          backgroundImage: `url(${CompanyNotFoundBg})`,
          backgroundSize: 'cover', // or try '100% 100%' if 'cover' still crops
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundColor: '#002940',
          width: '100%',
          height: '100%',
          imageRendering: 'auto', // prevents pixelation
        }}
      >
        <div className="w-full md:w-[221px]">
          <h4 className="mb-2 text-[32px] font-semibold tracking-tight text-white font-sans">
            Company Not Found?
          </h4>
          <p className="mb-3 font-light text-white text-f16 font-sans">
            Order a fresh report on a company now.
          </p>
          <button
            className="inline-flex items-center text-sm font-medium text-center"
            onClick={handleSwitch}
          >
            <Link to={"/create-company"} state={{ redirectToStep: 6 }}>
              <img src={ArrowNext} alt="arrow" />
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
};
